export default __webpack_public_path__ + "static/media/user-check-circle-tc.3be213f6.svg";